module.exports = __webpack_public_path__ + "img/default1.f5fc89d1.png";